const s = "google_my_business__posts", o = "facebook__posts", S = "instagram__posts", I = [s, o, S];
var t = /* @__PURE__ */ ((_) => (_.INSTAGRAM = "instagram__posts", _.FACEBOOK = "facebook__posts", _.GOOGLE = "google_my_business__posts", _.STORE_LOCATOR = "store_locator__posts", _))(t || {}), O = /* @__PURE__ */ ((_) => (_.GOOGLE = "google_my_business", _.FACEBOOK = "facebook", _.INSTAGRAM = "instagram", _.STORE_LOCATOR = "store_locator", _))(O || {});
const n = "business_is_draft", c = "business_is_not_subscribed_to_pm", E = "publisher_connection_required", i = "publisher_scope_missing", R = "business_not_diffusible", B = "this_business_is_closed";
export {
  I as ALL_PUBLISHERS,
  B as BUSINESS_IS_CLOSED,
  n as BUSINESS_IS_DRAFT,
  R as BUSINESS_IS_NOT_DIFFUSIBLE,
  c as BUSINESS_IS_NOT_SUBSCRIBED_TO_PM,
  E as PUBLISHER_CONNECTION_REQUIRED,
  o as PUBLISHER_FACEBOOK,
  s as PUBLISHER_GOOGLE,
  S as PUBLISHER_INSTAGRAM,
  i as PUBLISHER_SCOPE_MISSING,
  t as PostDiffuserNameEnum,
  O as PostPublisherNameEnum
};
